import { render, staticRenderFns } from "./getBodyEmail.vue?vue&type=template&id=01c8b2cc&"
import script from "./getBodyEmail.vue?vue&type=script&lang=js&"
export * from "./getBodyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports